import Alert from '@zoom/zoom-ui/src/components/alert';
import './alert.scss';

export default {
  extends: Alert,
  props: {
    closable: Boolean, // set closable default false
  },
  render(createElement) {
    const vnode = Alert.render.call(this, createElement);

    // insert icon slot when showIcon is false
    if (!this.showIcon && this.$slots.icon) {
      vnode.componentOptions.children[0].children.unshift(createElement('div', { class: 'zm-alert__icon', attrs: { 'aria-hidden': true } }, this.$slots.icon));
    }

    return vnode;
  },
};
